import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const ViewStock = () => {
  const [productData, setProductData] = useState([]);
  const [copyProductData, setCopyProductData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sizeDrpData, setSizeDrpData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [subCategoryDrp, setSubCategoryDrp] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [supplierId, setSupplierId] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [sizeId, setSizeId] = useState(null);

  const getProducts = () => {
    setLoading(true);
    axios
      .post(API_URL.PRODUCT_SUPPLIER, {
        supplier_id: supplierId ? supplierId.value : null
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data);
            setCopyProductData(res.data.data);
            let subCategory = [];
            let sizes = [];
            res.data.data.forEach((row) => {
                let exist = subCategory.find((r) => r.value == row.sub_category_id);
                let sizeExist = sizes.find((r) => r.value == row.size_id);
                if (!exist) {
                  subCategory.push({
                    label: row.sub_category_name,
                    value: row.sub_category_id,
                  });
                }
                if (!sizeExist) {
                    sizes.push({
                    label: row.size_name,
                    value: row.size_id,
                  });
                }
                setSubCategoryDrp(subCategory);
                setSizeDrpData(sizes);
            });
          }
          setIsLoaded(false);
          setLoading(false);
        },
        () => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };
  
  const getSuppliers = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [1]}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSupplierData(cd);
    });
  };

  const styles = {
    menu: (baseStyles) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getSuppliers();
  }, []);

  useEffect(() => {
    if (supplierId) {
      getProducts();
    } else {
      setProductData([]);
      setCopyProductData([]);
      setSubCategoryDrp([]);
      setSizeDrpData([]);
    }
  }, [supplierId]);

    useEffect(() => {
        if (subCategoryId && sizeId) {
            const data = copyProductData.filter((r) => r.sub_category_id == subCategoryId.value && r.size_id == sizeId.value);
            setProductData(data);
        } else if (subCategoryId) {
            const data = copyProductData.filter((r) => r.sub_category_id == subCategoryId.value);
            setProductData(data);
        } else if (sizeId) {
            const data = copyProductData.filter((r) => r.size_id == sizeId.value);
            setProductData(data);
        } else {
            setProductData([]);
        }
    }, [subCategoryId, sizeId]);

  const printStock = () => {
    setTimeout(() => {
      window.print();
    }, 300);
  };

  return (
    <>
      <div className="row">
        <div className="col-2 hidden-print">
          <h1>
            View Stocks
          </h1>
        </div>
        <div className="col-10 hidden-print">
          <div className="d-flex align-items-center justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
                <Select
                    placeholder="Select Supplier"
                    className="form-control-sm"
                    style={{ border: "1px solid lightgray" }}
                    options={supplierData}
                    isClearable
                    value={supplierId}
                    styles={styles}
                    onChange={(e) => {
                      setSupplierId(e);
                      setSubCategoryId(null);
                      setSizeId(null);
                    }}
                />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Category"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={subCategoryDrp}
                isClearable
                value={subCategoryId}
                styles={styles}
                onChange={(e) => {
                  setSubCategoryId(e);
                }}
              />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Size"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={sizeDrpData}
                isClearable
                value={sizeId}
                styles={styles}
                onChange={(e) => {
                  setSizeId(e);
                }}
              />
            </div>
            <button className="btn btn-primary" onClick={() => printStock()}>
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Print Stock
            </button>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card" id="view-stock">
            <div className="card-body p-0">
              {loading && <Loader />}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="100">Image</th>
                        <th>Name</th>
                        <th>In Stock</th>
                        <th>Category</th>
                        <th>Size</th>
                        <th>Series</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => (
                        <tr key={key}>
                          <td className="table-avatar">
                            <div
                              style={{
                                backgroundImage: "url(" + row.image + ")",
                                height: 50,
                                width: 50,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                            ></div>
                          </td>
                          <td>{row.name}</td>
                          <td style={{ fontSize: "18px" }}><strong>{row.in_stock}</strong></td>
                          <td>{row.sub_category_name}</td>
                          <td>{row.size_name}</td>
                          <td>
                              {row.series.map((r) => {
                                return (
                                  <span key={r.id} className="badge badge-primary">
                                    {r.name}
                                  </span>
                                )
                              })}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewStock;
